import React from "react";

export default function Loader({ label = "Loading...", className = "" }) {
  const classes = ["qtech-loader-wrap", className].filter(Boolean).join(" ");

  return (
    <div className={classes} role="status" aria-live="polite" aria-busy="true">
      <span className="loader" aria-hidden="true" />
      {label ? <span className="qtech-loader-text">{label}</span> : null}
    </div>
  );
}
